import { AISuggestionProps } from '../Types'
import { ReviseButton } from 'components/BlazeCommandLine/components/ReviseButton'
import { RevisionAction, RevisionType } from 'components/BlazeCommandLine/Types'
import Styles from '../AIRequestDrawer.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { useState } from 'react'
import { ListSelect } from 'components/ListSelect/ListSelect'
import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'

export const ChangeLength = ({ articleId, layerId, editorState, onRevise, promptProps }: AISuggestionProps) => {
  const [length, setLength] = useState(RevisionAction.MAKE_SHORTER)

  const handleChange = (selection: Selection) => {
    if (!(selection instanceof Set)) return

    const [action] = selection
    setLength(action as RevisionAction)
  }

  return (
    <div className={Styles.suggestedAction}>
      <Text variant="placeholder" color="var(--dark-80)">
        Desired length
      </Text>

      <ListSelect selectedKeys={[length]} selectionMode="single" onSelectionChange={handleChange}>
        <Item key={RevisionAction.MAKE_SHORTER}>Make shorter</Item>
        <Item key={RevisionAction.MAKE_LONGER}>Make longer</Item>
        <Item key={RevisionAction.SUMMARIZE}>Summarize</Item>
        <Item key={RevisionAction.SIMPLIFY}>Simplify</Item>
      </ListSelect>

      <ReviseButton
        almanacEditorState={editorState}
        articleId={articleId}
        layerId={layerId}
        label="Change Length"
        onRevise={onRevise}
        prompt={{ revision_type: RevisionType.CHANGE_LENGTH, action: length }}
        {...promptProps}
      />
    </div>
  )
}
